import { ServicePointServiceMock } from "./servicePoint.types";

export const mockServicePointService = (): ServicePointServiceMock => ({
  fetchServicePointById: jest.fn(),
  fetchServicePoints: jest.fn(),
});
